import React from 'react';
import { Sidebar, Toast } from '@insurancemenu/imenu-components-lib';
import Notes from 'components/common/group/sidebar/Notes';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import { useRootStore } from 'store/rootStore';
import ContactInfo from 'components/common/group/sidebar/ContactInfo';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { observer } from 'mobx-react-lite';
import AdditionalAccess from 'components/common/group/sidebar/AdditionalAccess';
import { useParams } from 'react-router-dom';
import Attachments from 'components/common/group/sidebar/Attachments';
import AssignedInfo from './AssignedInfo';
import { createStyles } from './styles';
import InviteAdmin from './InviteAdmin';

const GroupInfoSidebar = observer((): JSX.Element => {
  const { groupId } = useParams<{ groupId: string }>();

  // Mobx store
  const {
    groupInfoController: { pageLoading },
    groupSidebarStore: { showToast, toastMessage, setErrorToastStatus },
  } = useRootStore();
  const classes = createStyles();

  const onToastClose = (): void => {
    setErrorToastStatus(false, '');
  };

  return (
    <Sidebar className={classes.sidebar}>
      <ContactInfo />
      <InviteAdmin />
      <AssignedInfo />
      <AdditionalAccess groupId={groupId} editableType="ICON" />
      <Notes />
      <Attachments />
      <FormsSpinner display={pageLoading} />
      <Toast
        id="successfull-invitation-message"
        show={showToast}
        onClose={onToastClose}
        colorType={ToastColorTypes.SUCCESS}
        className={classes.sidebarToast}
      >
        {toastMessage}
      </Toast>
    </Sidebar>
  );
});

export default GroupInfoSidebar;
